/**
 * Places API Service
 * Fetches contact details and opening hours for a specific place on demand.
 * Called only when a card overlay opens — never during list searches.
 */

export class PlacesService {
  constructor(apiClient, errorHandler) {
    this.apiClient = apiClient;
    this.handleApiError = errorHandler;
  }

  /**
   * Get contact details and opening hours for a place.
   * Results are cached 24 h server-side per place_id.
   *
   * @param {string} placeId - Google Place ID
   * @returns {Promise<{place_id, phone, website, opening_hours}|null>}
   */
  async getPlaceDetails(placeId) {
    try {
      const response = await this.apiClient.get(
        `/places/${encodeURIComponent(placeId)}/details`
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching place details for', placeId, error);
      return null; // graceful degradation — overlay still works without details
    }
  }
}

export default PlacesService;
